export default "__VITE_ASSET__CKqr92BM__"